<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import type { FStepperStepProps, FStepperStepExpose } from '@/components/feature/FStepper/types'

defineProps<FStepperStepProps>()

defineModel<Record<string, unknown>>({ required: true })

const { t } = useI18n()

const stepCompleted = ref(true)

defineExpose<FStepperStepExpose>({ stepCompleted })
</script>

<template>
  <section>
    <h3 class="text-headline-small mb-2">
      {{ t('sign_agreements.missing_creditor_signatures') }}
    </h3>
    <p class="text-body-large text-medium-emphasis">
      {{ t('sign_agreements.missing_creditor_signatures_text') }}
    </p>
  </section>
</template>
